import { FINAL_STATUS } from '../../../constants'

// Options the linter complained about as `any`-typed inline literal — preserved
// flexibility by widening to the runtime entry shape.
type FinalStatusOption = (typeof FINAL_STATUS)[number]

// Hidden status sets per current state. Pulled out of the component so the
// useMemo body stays a one-liner — keeps cognitive complexity down.
const HIDDEN_AFTER_PASS_INTERVIEW = new Set([
    'Interview',
    'Từ chối phỏng vấn',
    'Fail Screen CV',
])

// availableFinalStatusButtons returns which final-status buttons should be
// shown for a given current final_status. Centralises the state-machine logic
// outside of the JSX-heavy component.
export const availableFinalStatusButtons = (
    currentFinal: string | undefined
): FinalStatusOption[] => {
    const baseOptions = FINAL_STATUS.filter((s) => !s.disable)
    if (!currentFinal) return baseOptions
    if (currentFinal === 'Interview') {
        return baseOptions.filter((s) => s.value !== 'Interview')
    }
    if (currentFinal === 'Pass Interview') {
        return baseOptions.filter(
            (s) => !HIDDEN_AFTER_PASS_INTERVIEW.has(s.value)
        )
    }
    return []
}
